const maskList = [
  { "code": "+7 ### ### ## ##" },
];

const DEFAULT_MATRIX = '+###############';

export function phoneMask(value: string) {

  if (value === '') {
    return value;
  }

  const matrix = maskList.reduce((acc, item) => {
    const code = item.code.replace(/[\s#]/g, '');
    const phone = value.replace(/[\s#-)(]/g, '');

    if (phone.includes(code)) {
      acc = item.code;
    }

    return acc;
  }, DEFAULT_MATRIX);

  let i = 0;
  const val = value.replace(/\D/g, '');

  return matrix.replace(/(?!\+)./g, function(a) {
    return /[#\d]/.test(a) && i < val.length ? val.charAt(i++) : i >= val.length ? '' : a;
  });
}
